// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue-instant/dist/vue-instant.css
// module id = 273
// module chunks = 0